<template>
  <StoreCartSection type="coupon" title="">
    <template v-if="appliedCoupon && appliedCoupon.code">
      <StoreCartSectionButton
        icon="TeenyiconsDiscountOutline"
        :label="appliedCoupon.code"
        :desc="$t('applied_coupon')"
        action="remove"
        :readonly="readonly"
        @action="upsertCart({ resetCoupon: true })"
      />
      <p class="border-t-2 border-dashed text-success-600 py-2 px-4 text-xs">
        {{ $t("saved") }}
        <Amount :value="appliedCoupon.discountedAmount" />
        {{ $t("with_this_coupon") }}
      </p>
    </template>

    <StoreCartSectionButton
      v-else
      icon="TeenyiconsDiscountOutline"
      :label="$t('apply_coupon')"
      @click="$nuxt.callHook('modal-open', 'modal-coupons')"
    />

    <ModalCoupon />
  </StoreCartSection>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useVepaarStore } from "@/store/store.js";
import { useCartStore } from "@/store/cart.js";

export default {
  props: {
    appliedCoupon: {
      type: Object,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(useVepaarStore, ["hash", "currencySymbol"]),
    ...mapState(useCartStore, ["cart"]),
  },
  methods: {
    ...mapActions(useCartStore, ["upsertCart"]),
  },
};
</script>
